import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentMailInbox: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M6.25 3h11.5a3.25 3.25 0 013.245 3.066L21 6.25v11.5a3.25 3.25 0 01-3.066 3.245L17.75 21H6.25a3.25 3.25 0 01-3.245-3.066L3 17.75V6.25a3.25 3.25 0 013.066-3.245L6.25 3h11.5-11.5zM4.5 14.5v3.25a1.75 1.75 0 001.606 1.744l.144.006h11.5a1.75 1.75 0 001.744-1.607l.006-.143V14.5h-3.825a3.752 3.752 0 01-3.475 2.995l-.2.005a3.752 3.752 0 01-3.632-2.812l-.043-.188H4.5v3.25-3.25zm13.25-10H6.25a1.75 1.75 0 00-1.744 1.606L4.5 6.25V13H9a.75.75 0 01.743.648l.007.102a2.25 2.25 0 004.495.154l.005-.154a.75.75 0 01.648-.743L15 13h4.5V6.25a1.75 1.75 0 00-1.607-1.744L17.75 4.5z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentMailInbox
